<template>
    <div>
        <div v-if="loaded">
            <slot></slot>
        </div>
        <div v-if="!loaded" class="text-center">
            <i class="fa fa-spinner fa-spin"></i>
        </div>
    </div>

</template>

<script>
    export default {

        props: {
            'database': {
                type: String,
                required: true,
            },
            items: {
                default: () => [],
            },
            codes: {
                type: Object,
                required: true,
            },
            root: {
                type: String,
                required: false,
            },
        },

        data() {
            return {
                loaded: false,
                response: null,
                tree: {
                    database: this.database,
                    opened: [],
                    loaded: [], // which nodes do we need to load!
                    required: [], // nodes that are required to restore from loading.
                    nodes: [],
                    root: [],
                    visible: null, // decide if a node is visible
                    loading: [], // nodes currently under load.
                    items: {},
                }
            }
        },

        provide() {
            return {
                tree: this.tree,
            };
        },

        watch: {
            database() {
                this.init();
            },
            'tree.opened'() {
                this.loadManyItems(this.tree.opened);
            },
            items: function () {
                this.loadManyItems(this.items);
            },
            'codes.selected'() {
                this.loadManyItems(this.requiredItems);
            }
        },

        created() {
            this.init();
        },

        computed: {
            requiredItems() {
                return this.codes.selected
                    .map(function (code) {
                        return code.path;
                    })
                    //.flat()
                    .reduce((acc, val) => acc.concat(val), []) // flat() - internet explorer does not like it.
                    .concat(this.items).filter((item) => {
                        return item.length > 0;
                    });//.uniq();
            },
        },

        methods: {
            init() {
                if (!this.root) {
                    this.loadRoot();
                } else {
                    this.loadCustomRoot();
                }

                if (this.requiredItems.length === 0) {
                    this.loaded = true;
                }
                this.loadManyItems(this.requiredItems)
            },
            isLoaded(id) {
                return this.tree.loaded.includes(id);
            },
            loadManyItems(items) {
                if (items.length === 0) {
                    return;
                }
                let that = this;

                // just load items that are indeed needed
                let group = items.filter(function (item) {
                    return !that.isLoaded(item);
                });


                this.tree.loading = this.tree.loading.concat(group);
                this.loadNode(group.join(','));
            },
            loadNode(id) {
                let that = this;

                if (that.tree.nodes[id] || id.length === 0) {
                    return;
                }

                that.loading = true;

                window.http.get('/api/v1/indicators/' + this.database + '/tree?id=' + id)
                    .then((response) => {

                        that.loaded = true;
                        that.loading = false;
                        that.tree.required.push(...Object.keys(response.data));

                        that.tree.items = {...that.tree.items, ...response.data};

                        Object.keys(response.data).forEach(function (id) {
                            that.tree.nodes[id] = response.data[id];
                            that.tree.loaded.push(id);
                            that.tree.loading = that.tree.loading.filter(function (item) {
                                return item !== id;
                            });
                        });
                    });
            },
            loadRoot() {
                let that = this;
                window.http.get('/api/v1/indicators/' + this.database + '/tree').then((response) => {
                    that.tree.root = response.data.data;
                    Object.keys(response.data).forEach(function (id) {
                        that.tree.nodes[id] = response.data[id];
                        that.tree.loaded.push(id);
                        that.tree.loading = that.tree.loading.filter(function (item) {
                            return item !== id;
                        });
                    });
                });
            },
            loadCustomRoot() {
                let that = this;
                window.http.get('/api/v1/indicators/' + this.database + '/tree?id=' + this.root).then((response) => {
                    that.tree.root = response.data[this.root];
                    Object.keys(response.data).forEach(function (id) {
                        that.tree.nodes[id] = response.data[id];
                        that.tree.loaded.push(id);
                        that.tree.loading = that.tree.loading.filter(function (item) {
                            return item !== id;
                        });
                    });
                });
            }
        }
    }
</script>
